import PropTypes from 'prop-types';
import React, { Component } from 'react';

import {isEqual} from 'lodash';

// Working m3u8 sample here:
// {src:"https://d2zihajmogu5jn.cloudfront.net/bipbop-advanced/bipbop_16x9_variant.m3u8", type:"application/x-mpegURL"}
// Working mp4 sample here:
// return "https://www.w3schools.com/html/mov_bbb.mp4";


export default class VideoJS extends Component {
  static propTypes = {
    caption: PropTypes.string,
    autoPlay: PropTypes.bool,
    onPlaying: PropTypes.func,
    onEnded: PropTypes.func,
    onError: PropTypes.func,
    src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    children: PropTypes.node
  };

  componentDidUpdate(prevProps) {
    if (!isEqual(this.props.src, prevProps.src)) {
      this.player.src(this.props.src);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);
  }

  componentDidMount() {
    // videojs is added as a global by manually adding the scripts in the HTML component
    const playerProps = {
      controls: true
    };

    playerProps.techOrder = ["html5", "youtube"];

    this.player = global.videojs(this.videoNode, playerProps);

    if (this.player) {
      this.player.src(this.props.src);

      this.player.on("ready", () => {
        if (this.props.autoPlay) {
          this.player.play();
        }
      });

      ["Playing", "Ended", "Error"].forEach(e => {
        const evName = e.toLowerCase();
        const propName = `on${e}`;

        this.player.on(evName, evt => {
          if (this.props[propName]) {
            this.props[propName](evt, this.player);
          }
        });
      });
    }
  }

  componentWillUnmount() {
    // it appears we need to ensure dispose happens *after* React has unmounted the player
    setTimeout(() => this.player.dispose(), 100);
  }

  getNode(node) {
    this.videoNode = node
  }

  render() {
    let fallbackText;
    const {caption} = this.props;

    if (caption) {
      fallbackText = `${caption} - video element not supported`;
    }
    else {
      fallbackText = "Video element not supported";
    }

    return (
      <div data-vjs-player>
        <video ref={node => this.getNode(node)} className="video-js">{fallbackText}</video>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./modules/Common/components/VideoJS.js